// extracted by mini-css-extract-plugin
export default {"screenMobile":"ScreenMobile_screenMobile__yg5Uq","screenMobile--icon":"ScreenMobile_screenMobile--icon__Ohu1u"};